import {uploadVideoApi} from '../../redux/api/media';
import {IVideo} from '@wholesalechange/chatcomponent';
import {FileWithPath} from 'react-dropzone';

interface IUseUploadVideo {
  uploadVideoAsync: (file: FileWithPath, dialogId: number | null, type: string) => Promise<IVideo>
}

export function useUploadVideo(): IUseUploadVideo {
  async function uploadVideoAsync(file: FileWithPath, dialogId: number | null, type: string): Promise<IVideo> {
    const arrayBuffer = await file.arrayBuffer();
    const byteData = new Uint8Array(arrayBuffer);
    const safeFilename = encodeURIComponent(file.name);
    const {data: video} = await uploadVideoApi(byteData, safeFilename, dialogId, type);

    return video;
  }

  return {
    uploadVideoAsync
  };
}
